import React, { useState, useEffect, useRef } from "react";
import { Row, Col, Button, Form, Alert as AlertControl } from "react-bootstrap";
// Import Datepicker
import { DatePickerInput } from "rc-datepicker";
import Select, { components } from "react-select";
import ServiceCarander from "./service/ServiceCarander";
// Import the default style
import "rc-datepicker/lib/style.css";
import "./FormCarander.css";
import ServiceAdmin from "../../HomePage/PageHomeAdmin/Services/ServiceAdmin";
import moment from "moment";
import Navbar from "../../Member/Navbar/Navbar";
const SingleValue = ({ children, ...props }) => (
  <components.SingleValue {...props}>{children}</components.SingleValue>
);
const FormCarander = (props) => {
  // checked Labo or Midecin
  const healthProId = JSON.parse(sessionStorage.getItem("user")).id;
  const [ProfInfos, setProfInfos] = useState("");
  useEffect(() => {
    getprofileInfo();
  }, []);

  //
  const getprofileInfo = () => {
    ServiceAdmin.getprofile(healthProId).then((res) => {
      console.log("api get ", res.data);
      if (res.data) {
        setProfInfos(res.data);
        sessionStorage.setItem("profSante", JSON.stringify(res.data));
        // setDetailsInfo(JSON.parse(res.data.laboratory));
      }
    });
  };

  console.log(ProfInfos.speciality);
  const { history } = props;
  /// select

  const [typePlan, setType] = useState("No covid"); //type vide ??
  const [capacity, setCapacite] = useState("");
  const [designation, setDesignation] = useState("");
  const [datePlaning, setSelectedDate] = useState(new Date());

  const user = {
    id: JSON.parse(sessionStorage.getItem("user")).id,
  };

  const [timeSL1, setTimeSL1] = useState(null);
  const [timeSL2, setTimeSL2] = useState(null);
  const [timeSL3, setTimeSL3] = useState(null);
  const [timeSL4, setTimeSL4] = useState(null);
  const [timeSL5, setTimeSL5] = useState(null);
  const [timeSL6, setTimeSL6] = useState(null);
  const [timeSL7, setTimeSL7] = useState(null);
  const [timeSL8, setTimeSL8] = useState(null);
  const [timeSL9, setTimeSL9] = useState(null);
  const [timeSL10, setTimeSL10] = useState(null);
  const [timeSL11, setTimeSL11] = useState(null);
  const [timeSL12, setTimeSL12] = useState(null);
  const [timeSL13, setTimeSL13] = useState(null);
  const [timeSL14, setTimeSL14] = useState(null);
  const [timeSL15, setTimeSL15] = useState(null);
  const [timeSL16, setTimeSL16] = useState(null);
  const [timeSL17, setTimeSL17] = useState(null);
  const [timeSL18, setTimeSL18] = useState(null);
  const [timeSL19, setTimeSL19] = useState(null);
  const [timeSL20, setTimeSL20] = useState(null);
  const [timeSL21, setTimeSL21] = useState(null);
  const [timeSL22, setTimeSL22] = useState(null);
  const [timeSL23, setTimeSL23] = useState(null);
  const [timeSL24, setTimeSL24] = useState(null);
  const [timeSL25, setTimeSL25] = useState(null);
  const [timeSL26, setTimeSL26] = useState(null);
  const [timeSL27, setTimeSL27] = useState(null);
  const [timeSL28, setTimeSL28] = useState(null);
  const [timeSL29, setTimeSL29] = useState(null);
  const [timeSL30, setTimeSL30] = useState(null);
  const [timeSL31, setTimeSL31] = useState(null);
  const [timeSL32, setTimeSL32] = useState(null);
  const [timeSL33, setTimeSL33] = useState(null);
  const [timeSL34, setTimeSL34] = useState(null);
  const [timeSL35, setTimeSL35] = useState(null);
  const [timeSL36, setTimeSL36] = useState(null);
  const [timeSL37, setTimeSL37] = useState(null);
  const [timeSL38, setTimeSL38] = useState(null);
  const [timeSL39, setTimeSL39] = useState(null);
  const [timeSL40, setTimeSL40] = useState(null);
  const [timeSL41, setTimeSL41] = useState(null);
  const [timeSL42, setTimeSL42] = useState(null);
  const [timeSL43, setTimeSL43] = useState(null);
  const [timeSL44, setTimeSL44] = useState(null);
  const [timeSL45, setTimeSL45] = useState(null);
  const [timeSL46, setTimeSL46] = useState(null);
  const [timeSL47, setTimeSL47] = useState(null);
  const [timeSL48, setTimeSL48] = useState(null);

  // console.log(
  //   designation,
  //   datePlaning,
  //   capacity,
  //   timeSL1,
  //   timeSL2,
  //   timeSL3,
  //   timeSL4,
  //   timeSL5,
  //   timeSL6,
  //   timeSL7,
  //   timeSL8,
  //   timeSL9,
  //   timeSL10,
  //   timeSL11,
  //   timeSL12,
  //   timeSL13,
  //   timeSL14,
  //   timeSL15,
  //   timeSL16,
  //   timeSL17,
  //   timeSL18,
  //   timeSL19,
  //   timeSL20,
  //   timeSL21,
  //   timeSL22,
  //   timeSL23,
  //   timeSL24,
  //   timeSL25,
  //   timeSL26,
  //   timeSL27,
  //   timeSL28,
  //   timeSL29,
  //   timeSL30,
  //   timeSL31,
  //   timeSL32,
  //   timeSL33,
  //   timeSL34,
  //   timeSL35,
  //   timeSL36,
  //   timeSL37,
  //   timeSL38,
  //   timeSL39,
  //   timeSL40,
  //   timeSL41,
  //   timeSL42,
  //   timeSL43,
  //   timeSL44,
  //   timeSL45,
  //   timeSL46,
  //   timeSL47,
  //   timeSL48,
  //   typePlan,
  //   user,
  //   moment(datePlaning).format("DD/MM/YYYY")
  // );

  const HandlePlanning = (e) => {
    ServiceCarander.createplanning(
      designation,
      datePlaning,
      capacity,
      timeSL1,
      timeSL2,
      timeSL3,
      timeSL4,
      timeSL5,
      timeSL6,
      timeSL7,
      timeSL8,
      timeSL9,
      timeSL10,
      timeSL11,
      timeSL12,
      timeSL13,
      timeSL14,
      timeSL15,
      timeSL16,
      timeSL17,
      timeSL18,
      timeSL19,
      timeSL20,
      timeSL21,
      timeSL22,
      timeSL23,
      timeSL24,
      timeSL25,
      timeSL26,
      timeSL27,
      timeSL28,
      timeSL29,
      timeSL30,
      timeSL31,
      timeSL32,
      timeSL33,
      timeSL34,
      timeSL35,
      timeSL36,
      timeSL37,
      timeSL38,
      timeSL39,
      timeSL40,
      timeSL41,
      timeSL42,
      timeSL43,
      timeSL44,
      timeSL45,
      timeSL46,
      timeSL47,
      timeSL48,
      typePlan,
      user
    ).then((res) => {
      window.location.reload();
      window.location.replace("/programe");
    });
  };

  const [contorl, setControl] = useState(false);

  return (
    <>
      <Navbar />
      <div className="form calendar">
        <h2>Calendrier</h2> <hr />
        <>
          <Row>
            <Col lg={5}>
              <Form.Control
                style={{ marginTop: "40px" }}
                type="text"
                required
                placeholder="Désignation"
                value={designation}
                onChange={(e) => {
                  setDesignation(e.target.value);
                  setControl(false);
                }}
              />

              <DatePickerInput
                minDate={new Date()}
                onChange={(date) => setSelectedDate(date.toISOString())}
                value={datePlaning}
                required
                className="my-custom-datepicker-component mb-4"
              />

              {!ProfInfos.speciality && (
                <Form.Group controlId="calendar.SelectCustom">
                  <Form.Control
                    as="select"
                    custom
                    required
                    defaultValue="No Covid"
                    onChange={(e) => {
                      setType(e.target.value);
                    }}
                  >
                    <option>No Covid</option>
                    <option>Covid</option>
                  </Form.Control>
                </Form.Group>
              )}

              <Form.Control
                type="text"
                placeholder="Capacité par tranche d'horaire"
                className="mb-4"
                required
                value={capacity}
                onChange={(e) => {
                  setCapacite(e.target.value);
                  setControl(false);
                }}
              />
              {contorl && (
                <AlertControl variant="warning">
                  Tous les champs sont obligatoires
                </AlertControl>
              )}
            </Col>

            <Col lg={7} sm={12}>
              <h5>Sélectionnez les heures souhaitées :</h5>
              <div className="time">
                <h4>Matin :</h4>
                <Row>
                  <span
                    onClick={(e) => {
                      if (timeSL1) {
                        setTimeSL1(null);
                        e.target.style.backgroundColor = "#0097e6";
                      } else {
                        setTimeSL1(e.target.innerText);

                        e.target.style.backgroundColor = "#2ecc71";
                      }
                    }}
                  >
                    06:00
                  </span>
                  <span
                    onClick={(e) => {
                      if (timeSL2) {
                        setTimeSL2(null);
                        e.target.style.backgroundColor = "#0097e6";
                      } else {
                        setTimeSL2(e.target.innerText);
                        e.target.style.backgroundColor = "#2ecc71";
                      }
                    }}
                  >
                    06:30
                  </span>
                  <span
                    onClick={(e) => {
                      if (timeSL3) {
                        setTimeSL3(null);
                        e.target.style.backgroundColor = "#0097e6";
                      } else {
                        setTimeSL3(e.target.innerText);
                        e.target.style.backgroundColor = "#2ecc71";
                      }
                    }}
                  >
                    07:00
                  </span>
                  <span
                    onClick={(e) => {
                      if (timeSL4) {
                        setTimeSL4(null);
                        e.target.style.backgroundColor = "#0097e6";
                      } else {
                        setTimeSL4(e.target.innerText);
                        e.target.style.backgroundColor = "#2ecc71";
                      }
                    }}
                  >
                    07:30
                  </span>
                  <span
                    onClick={(e) => {
                      if (timeSL5) {
                        setTimeSL5(null);
                        e.target.style.backgroundColor = "#0097e6";
                      } else {
                        setTimeSL5(e.target.innerText);
                        e.target.style.backgroundColor = "#2ecc71";
                      }
                    }}
                  >
                    08:00
                  </span>
                  <span
                    onClick={(e) => {
                      if (timeSL6) {
                        setTimeSL6(null);
                        e.target.style.backgroundColor = "#0097e6";
                      } else {
                        setTimeSL6(e.target.innerText);
                        e.target.style.backgroundColor = "#2ecc71";
                      }
                    }}
                  >
                    08:30
                  </span>
                  <span
                    onClick={(e) => {
                      if (timeSL7) {
                        setTimeSL7(null);
                        e.target.style.backgroundColor = "#0097e6";
                      } else {
                        setTimeSL7(e.target.innerText);
                        e.target.style.backgroundColor = "#2ecc71";
                      }
                    }}
                  >
                    09:00
                  </span>
                  <span
                    onClick={(e) => {
                      if (timeSL8) {
                        setTimeSL8(null);
                        e.target.style.backgroundColor = "#0097e6";
                      } else {
                        setTimeSL8(e.target.innerText);
                        e.target.style.backgroundColor = "#2ecc71";
                      }
                    }}
                  >
                    09:30
                  </span>

                  <span
                    onClick={(e) => {
                      if (timeSL9) {
                        setTimeSL9(null);
                        e.target.style.backgroundColor = "#0097e6";
                      } else {
                        setTimeSL9(e.target.innerText);
                        e.target.style.backgroundColor = "#2ecc71";
                      }
                    }}
                  >
                    10:00
                  </span>
                  <span
                    onClick={(e) => {
                      if (timeSL10) {
                        setTimeSL10(null);
                        e.target.style.backgroundColor = "#0097e6";
                      } else {
                        setTimeSL10(e.target.innerText);
                        e.target.style.backgroundColor = "#2ecc71";
                      }
                    }}
                  >
                    10:30
                  </span>
                  <span
                    onClick={(e) => {
                      if (timeSL11) {
                        setTimeSL11(null);
                        e.target.style.backgroundColor = "#0097e6";
                      } else {
                        setTimeSL11(e.target.innerText);
                        e.target.style.backgroundColor = "#2ecc71";
                      }
                    }}
                  >
                    11:00
                  </span>
                  <span
                    onClick={(e) => {
                      if (timeSL12) {
                        setTimeSL12(null);
                        e.target.style.backgroundColor = "#0097e6";
                      } else {
                        setTimeSL12(e.target.innerText);
                        e.target.style.backgroundColor = "#2ecc71";
                      }
                    }}
                  >
                    11:30
                  </span>
                  <span
                    onClick={(e) => {
                      if (timeSL13) {
                        setTimeSL13(null);
                        e.target.style.backgroundColor = "#0097e6";
                      } else {
                        setTimeSL13(e.target.innerText);
                        e.target.style.backgroundColor = "#2ecc71";
                      }
                    }}
                  >
                    12:00
                  </span>
                  <span
                    onClick={(e) => {
                      if (timeSL14) {
                        setTimeSL14(null);
                        e.target.style.backgroundColor = "#0097e6";
                      } else {
                        setTimeSL14(e.target.innerText);
                        e.target.style.backgroundColor = "#2ecc71";
                      }
                    }}
                  >
                    12:30
                  </span>
                  <span
                    onClick={(e) => {
                      if (timeSL15) {
                        setTimeSL15(null);
                        e.target.style.backgroundColor = "#0097e6";
                      } else {
                        setTimeSL15(e.target.innerText);
                        e.target.style.backgroundColor = "#2ecc71";
                      }
                    }}
                  >
                    13:00
                  </span>
                </Row>
                <hr />
                <h4>Aprés-Midi :</h4>
                <Row>
                  <span
                    onClick={(e) => {
                      if (timeSL16) {
                        setTimeSL16(null);
                        e.target.style.backgroundColor = "#0097e6";
                      } else {
                        setTimeSL16(e.target.innerText);
                        e.target.style.backgroundColor = "#2ecc71";
                      }
                    }}
                  >
                    13:30
                  </span>
                  <span
                    onClick={(e) => {
                      if (timeSL17) {
                        setTimeSL17(null);
                        e.target.style.backgroundColor = "#0097e6";
                      } else {
                        setTimeSL17(e.target.innerText);
                        e.target.style.backgroundColor = "#2ecc71";
                      }
                    }}
                  >
                    14:00
                  </span>
                  <span
                    onClick={(e) => {
                      if (timeSL18) {
                        setTimeSL18(null);
                        e.target.style.backgroundColor = "#0097e6";
                      } else {
                        setTimeSL18(e.target.innerText);
                        e.target.style.backgroundColor = "#2ecc71";
                      }
                    }}
                  >
                    14:30
                  </span>
                  <span
                    onClick={(e) => {
                      if (timeSL19) {
                        setTimeSL19(null);
                        e.target.style.backgroundColor = "#0097e6";
                      } else {
                        setTimeSL19(e.target.innerText);
                        e.target.style.backgroundColor = "#2ecc71";
                      }
                    }}
                  >
                    15:00
                  </span>
                  <span
                    onClick={(e) => {
                      if (timeSL20) {
                        setTimeSL20(null);
                        e.target.style.backgroundColor = "#0097e6";
                      } else {
                        setTimeSL20(e.target.innerText);
                        e.target.style.backgroundColor = "#2ecc71";
                      }
                    }}
                  >
                    15:30
                  </span>
                  <span
                    onClick={(e) => {
                      if (timeSL21) {
                        setTimeSL21(null);
                        e.target.style.backgroundColor = "#0097e6";
                      } else {
                        setTimeSL21(e.target.innerText);
                        e.target.style.backgroundColor = "#2ecc71";
                      }
                    }}
                  >
                    16:00
                  </span>
                  <span
                    onClick={(e) => {
                      if (timeSL22) {
                        setTimeSL22(null);
                        e.target.style.backgroundColor = "#0097e6";
                      } else {
                        setTimeSL22(e.target.innerText);
                        e.target.style.backgroundColor = "#2ecc71";
                      }
                    }}
                  >
                    16:30
                  </span>
                  <span
                    onClick={(e) => {
                      if (timeSL23) {
                        setTimeSL23(null);
                        e.target.style.backgroundColor = "#0097e6";
                      } else {
                        setTimeSL23(e.target.innerText);
                        e.target.style.backgroundColor = "#2ecc71";
                      }
                    }}
                  >
                    17:00
                  </span>
                  <span
                    onClick={(e) => {
                      if (timeSL24) {
                        setTimeSL24(null);
                        e.target.style.backgroundColor = "#0097e6";
                      } else {
                        setTimeSL24(e.target.innerText);
                        e.target.style.backgroundColor = "#2ecc71";
                      }
                    }}
                  >
                    17:30
                  </span>

                  <span
                    onClick={(e) => {
                      if (timeSL25) {
                        setTimeSL25(null);
                        e.target.style.backgroundColor = "#0097e6";
                      } else {
                        setTimeSL25(e.target.innerText);
                        e.target.style.backgroundColor = "#2ecc71";
                      }
                    }}
                  >
                    18:00
                  </span>
                  <span
                    onClick={(e) => {
                      if (timeSL26) {
                        setTimeSL26(null);
                        e.target.style.backgroundColor = "#0097e6";
                      } else {
                        setTimeSL26(e.target.innerText);
                        e.target.style.backgroundColor = "#2ecc71";
                      }
                    }}
                  >
                    18:30
                  </span>
                </Row>
                <hr />
                <h4>Soir :</h4>
                <Row>
                  <span
                    onClick={(e) => {
                      if (timeSL27) {
                        setTimeSL27(null);
                        e.target.style.backgroundColor = "#0097e6";
                      } else {
                        setTimeSL27(e.target.innerText);
                        e.target.style.backgroundColor = "#2ecc71";
                      }
                    }}
                  >
                    19:00
                  </span>
                  <span
                    onClick={(e) => {
                      if (timeSL28) {
                        setTimeSL28(null);
                        e.target.style.backgroundColor = "#0097e6";
                      } else {
                        setTimeSL28(e.target.innerText);
                        e.target.style.backgroundColor = "#2ecc71";
                      }
                    }}
                  >
                    19:30
                  </span>
                  <span
                    onClick={(e) => {
                      if (timeSL29) {
                        setTimeSL29(null);
                        e.target.style.backgroundColor = "#0097e6";
                      } else {
                        setTimeSL29(e.target.innerText);
                        e.target.style.backgroundColor = "#2ecc71";
                      }
                    }}
                  >
                    20:00
                  </span>
                  <span
                    onClick={(e) => {
                      if (timeSL30) {
                        setTimeSL30(null);
                        e.target.style.backgroundColor = "#0097e6";
                      } else {
                        setTimeSL30(e.target.innerText);
                        e.target.style.backgroundColor = "#2ecc71";
                      }
                    }}
                  >
                    20:30
                  </span>
                  <span
                    onClick={(e) => {
                      if (timeSL31) {
                        setTimeSL31(null);
                        e.target.style.backgroundColor = "#0097e6";
                      } else {
                        setTimeSL31(e.target.innerText);
                        e.target.style.backgroundColor = "#2ecc71";
                      }
                    }}
                  >
                    21:00
                  </span>
                  <span
                    onClick={(e) => {
                      if (timeSL32) {
                        setTimeSL32(null);
                        e.target.style.backgroundColor = "#0097e6";
                      } else {
                        setTimeSL32(e.target.innerText);
                        e.target.style.backgroundColor = "#2ecc71";
                      }
                    }}
                  >
                    21:30
                  </span>
                  <span
                    onClick={(e) => {
                      if (timeSL33) {
                        setTimeSL33(null);
                        e.target.style.backgroundColor = "#0097e6";
                      } else {
                        setTimeSL33(e.target.innerText);
                        e.target.style.backgroundColor = "#2ecc71";
                      }
                    }}
                  >
                    22:00
                  </span>
                  <span
                    onClick={(e) => {
                      if (timeSL34) {
                        setTimeSL34(null);
                        e.target.style.backgroundColor = "#0097e6";
                      } else {
                        setTimeSL34(e.target.innerText);
                        e.target.style.backgroundColor = "#2ecc71";
                      }
                    }}
                  >
                    22:30
                  </span>
                  <span
                    onClick={(e) => {
                      if (timeSL35) {
                        setTimeSL35(null);
                        e.target.style.backgroundColor = "#0097e6";
                      } else {
                        setTimeSL35(e.target.innerText);
                        e.target.style.backgroundColor = "#2ecc71";
                      }
                    }}
                  >
                    23:00
                  </span>
                  <span
                    onClick={(e) => {
                      if (timeSL36) {
                        setTimeSL36(null);
                        e.target.style.backgroundColor = "#0097e6";
                      } else {
                        setTimeSL36(e.target.innerText);
                        e.target.style.backgroundColor = "#2ecc71";
                      }
                    }}
                  >
                    23:30
                  </span>
                  <span
                    onClick={(e) => {
                      if (timeSL37) {
                        setTimeSL37(null);
                        e.target.style.backgroundColor = "#0097e6";
                      } else {
                        setTimeSL37(e.target.innerText);
                        e.target.style.backgroundColor = "#2ecc71";
                      }
                    }}
                  >
                    00:00
                  </span>
                  <span
                    onClick={(e) => {
                      if (timeSL38) {
                        setTimeSL38(null);
                        e.target.style.backgroundColor = "#0097e6";
                      } else {
                        setTimeSL38(e.target.innerText);
                        e.target.style.backgroundColor = "#2ecc71";
                      }
                    }}
                  >
                    00:30
                  </span>
                  <span
                    onClick={(e) => {
                      if (timeSL39) {
                        setTimeSL39(null);
                        e.target.style.backgroundColor = "#0097e6";
                      } else {
                        setTimeSL39(e.target.innerText);
                        e.target.style.backgroundColor = "#2ecc71";
                      }
                    }}
                  >
                    01:00
                  </span>
                  <span
                    onClick={(e) => {
                      if (timeSL40) {
                        setTimeSL40(null);
                        e.target.style.backgroundColor = "#0097e6";
                      } else {
                        setTimeSL40(e.target.innerText);
                        e.target.style.backgroundColor = "#2ecc71";
                      }
                    }}
                  >
                    01:30
                  </span>

                  <span
                    onClick={(e) => {
                      if (timeSL41) {
                        setTimeSL41(null);
                        e.target.style.backgroundColor = "#0097e6";
                      } else {
                        setTimeSL41(e.target.innerText);
                        e.target.style.backgroundColor = "#2ecc71";
                      }
                    }}
                  >
                    02:00
                  </span>
                  <span
                    onClick={(e) => {
                      if (timeSL42) {
                        setTimeSL42(null);
                        e.target.style.backgroundColor = "#0097e6";
                      } else {
                        setTimeSL42(e.target.innerText);
                        e.target.style.backgroundColor = "#2ecc71";
                      }
                    }}
                  >
                    02:30
                  </span>
                  <span
                    onClick={(e) => {
                      if (timeSL43) {
                        setTimeSL43(null);
                        e.target.style.backgroundColor = "#0097e6";
                      } else {
                        setTimeSL43(e.target.innerText);
                        e.target.style.backgroundColor = "#2ecc71";
                      }
                    }}
                  >
                    03:00
                  </span>
                  <span
                    onClick={(e) => {
                      if (timeSL44) {
                        setTimeSL44(null);
                        e.target.style.backgroundColor = "#0097e6";
                      } else {
                        setTimeSL44(e.target.innerText);
                        e.target.style.backgroundColor = "#2ecc71";
                      }
                    }}
                  >
                    03:30
                  </span>
                  <span
                    onClick={(e) => {
                      if (timeSL45) {
                        setTimeSL45(null);
                        e.target.style.backgroundColor = "#0097e6";
                      } else {
                        setTimeSL45(e.target.innerText);
                        e.target.style.backgroundColor = "#2ecc71";
                      }
                    }}
                  >
                    04:00
                  </span>
                  <span
                    onClick={(e) => {
                      if (timeSL46) {
                        setTimeSL46(null);
                        e.target.style.backgroundColor = "#0097e6";
                      } else {
                        setTimeSL46(e.target.innerText);
                        e.target.style.backgroundColor = "#2ecc71";
                      }
                    }}
                  >
                    04:30
                  </span>
                  <span
                    onClick={(e) => {
                      if (timeSL47) {
                        setTimeSL47(null);
                        e.target.style.backgroundColor = "#0097e6";
                      } else {
                        setTimeSL47(e.target.innerText);
                        e.target.style.backgroundColor = "#2ecc71";
                      }
                    }}
                  >
                    05:00
                  </span>
                  <span
                    onClick={(e) => {
                      if (timeSL48) {
                        setTimeSL48(null);
                        e.target.style.backgroundColor = "#0097e6";
                      } else {
                        setTimeSL48(e.target.innerText);
                        e.target.style.backgroundColor = "#2ecc71";
                      }
                    }}
                  >
                    05:30
                  </span>
                </Row>
              </div>
              <Row>
                <button
                  className="btn2 home"
                  style={{ margin: "30px auto", width: "130px" }}
                  // type="button"
                  onClick={() =>
                    designation && capacity
                      ? HandlePlanning()
                      : setControl(true)
                  }
                >
                  Ajouter
                </button>
              </Row>
            </Col>
          </Row>
        </>
      </div>
    </>
  );
};

export default FormCarander;
